"use client";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";
import ButtonLink from "@/next-src/components/ui/button-link/ButtonLink";
import Accordion from "@/next-src/components/ui/accordion/Accordion";
import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";
import getResponsiveEl from "@/next-src/utils/getResponsiveEl";

import comCSS from "./Faq.module.scss";

const Faq = ({ className = "", data = {} }) => {
  const { width: windowWidth } = useWindowDimensions();
  const {
    preTitleMobile,
    titleMobile,
    textMobile,
    buttonMobile,
    faqs,
    bgColorMobile,
  } = data || {};

  let { preTitle, title, text, button, bgColor } = data || {};

  if (windowWidth < 992) {
    preTitle = preTitleMobile;
    title = titleMobile;
    text = textMobile;
    button = buttonMobile;
    bgColor = bgColorMobile;
  }

  const getAccordionData = (dataAc) =>
    dataAc
      ?.filter((el) => !el.hide)
      ?.map((el) => ({
        id: el.id,
        header: convertHTMLtoJSX(el.question),
        body: convertHTMLtoJSX(el.answer),
      }));
  return (
    <section
      className={cn(className, comCSS.wrapper, "section")}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div className="padding-global">
        <div className="container-large">
          <div className="padding-section-large">
            <div className="w-layout-grid faq6_component">
              <div className="faq6_content">
                {preTitle ? (
                  <div className="margin-bottom margin-xsmall">
                    <div className="text-note">
                      {convertHTMLtoJSX(preTitle)}
                    </div>
                  </div>
                ) : null}
                <div className="margin-bottom margin-small">
                  {convertHTMLtoJSX(title)}
                </div>
                <div className="text-size-medium">{convertHTMLtoJSX(text)}</div>
                <div className="margin-top margin-medium display-inlineflex">
                  <ButtonLink
                    data={button}
                    isArrowRight
                    className="is-secondary is-icon "
                  />
                </div>
              </div>
              <div className="accordion_list">
                {faqs
                  ?.filter((el) => !el.hide)
                  ?.map((el, index) => (
                    <Fragment key={el.id}>
                      <div
                        className={cn("accordion-category-headline", {
                          second: index > 0,
                        })}
                      >
                        {convertHTMLtoJSX(
                          getResponsiveEl(
                            windowWidth,
                            el,
                            "title",
                            "titleMobile"
                          )
                        )}
                      </div>
                      <Accordion
                        data={getAccordionData(el.items)}
                        headerClassName="text-weight-semibold"
                      />
                    </Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Faq.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    preTitle: PropTypes.string,
    preTitleMobile: PropTypes.string,
    title: PropTypes.string,
    titleMobile: PropTypes.string,
    text: PropTypes.string,
    textMobile: PropTypes.string,
    button: PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
      bgColor: PropTypes.string,
      bgColorHover: PropTypes.string,
      borderColor: PropTypes.string,
      borderColorHover: PropTypes.string,
      hide: PropTypes.bool,
    }),
    buttonMobile: PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
      bgColor: PropTypes.string,
      bgColorHover: PropTypes.string,
      borderColor: PropTypes.string,
      borderColorHover: PropTypes.string,
      hide: PropTypes.bool,
    }),
    faqs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        titleMobile: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            question: PropTypes.string,
            answer: PropTypes.string,
            hide: PropTypes.bool,
          })
        ),
        hide: PropTypes.bool,
      })
    ),
    bgColor: PropTypes.string,
    bgColorMobile: PropTypes.string,
  }),
};

export default Faq;
